import { Component } from '@angular/core';

import { NavigationEvent, NavigationEvents, NavigationService } from '@app/services';
import { PAGES } from '@app/shared/enums/pages/pages.enum';
import { ErrorInfoMessage } from '@app/shared/interfaces/error/error-info.interface';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.page.html'
})
export class NotFoundPage {
  errorInfo: ErrorInfoMessage = {
    title: 'PAGE_ERROR_404.TITLE',
    description: 'PAGE_ERROR_404.DESCRIPTION',
    icon_name: 'icon-alert',
    alt_image: 'assets/imgs/error-404/404-image.png',
    url_image: 'assets/imgs/error-404/not-found.svg',
    action_buttons: [
      {
        text: 'GO_BACK',
        type: 'primary',
        onClick: () => {
          this.goBack();
        }
      }
    ],
    version: true
  };

  constructor(private navigationService: NavigationService) {}

  private goBack() {
    const navEvent = new NavigationEvent(NavigationEvents.Push, { path: PAGES.HOME });
    this.navigationService.navigate(navEvent);
  }
}
